module.exports = __webpack_public_path__ + "img/рз_buttocks.1e1cedb1.png";